import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import sectionStyles from "../styles/Section.module.css";
import styles from "../styles/OurServices.module.css";
import dance from "../imgs/neko-dance.png";
import useScrollReveal from "../hooks/useScrollReveal";

const services = [
  "Custom Website Design & Development",
  "Responsive, Mobile-First Builds",
  "SEO, Analytics & Performance Tuning",
  "Branding, UI & Logo Design",
  "Secure Hosting & Deployment",
  "Fast Turnaround, Clear Communication",
  "Ongoing Maintenance & Support",
];

export default function OurServices() {
  const [headerRef, headerVisible] = useScrollReveal();
  const [gridRef, gridVisible] = useScrollReveal();

  return (
    <div className={styles.works}>
      <Container>
        <div
          ref={headerRef}
          className={`${sectionStyles.header} ${headerVisible ? sectionStyles.visible : ""}`}
        >
          <p className={`${sectionStyles.eyebrow} ${sectionStyles.eyebrowLight}`}>WHAT WE DO</p>
          <h2 className={`${sectionStyles.heading} ${sectionStyles.headingLight}`}>OUR SERVICES</h2>
          <p className={`${sectionStyles.subheading} ${sectionStyles.subheadingLight}`}>
            Everything you need to go from idea to a live, working website.
          </p>
        </div>
        <Row className={styles.contentRow}>
          <Col lg={5} className={styles.imageCol}>
            <img src={dance} alt="Neko Web Studios mascot" className={styles.imageContainer} />
          </Col>
          <Col lg={7}>
            <div ref={gridRef} className={`${styles.grid} ${gridVisible ? styles.visible : ""}`}>
              {services.map((service, index) => (
                <div
                  className={styles.chip}
                  key={service}
                  style={{ transitionDelay: `${index * 60}ms` }}
                >
                  {service}
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
